const AssetInward = {

    // FIELDS
    "premise": "Premise",
    "zone": "Zone",
    "level": "Level",
    "asset": "Asset",
    "name": "Name",
    "model_number": "Model Number",
    "search": "Search",

    // PAGE HEADER
    "assetInward": "Asset Inward",

    // ERROR
    "error_premise": "Select Premise",
    "error_zone": "Select Zone",
    "error_level": "Select Level",
    "error_asset": "Select Asset",
    "error_name": "Enter Name",
    "error_model_number": "Enter Model Number",

    // TABLE HEADER
    "table_premise": "PREMISE",
    "table_zone": "ZONE",
    "table_level": "LEVEL",
    "table_asset": "ASSET",
    "table_name": "NAME",
    "table_code": "CODE",
    "table_model_number": "MODEL NUMBER",

}

export default AssetInward;